import {
  Box,
  Button,
  TextField,
  FormControl,
  MenuItem,
  Select,
  InputLabel,
} from "@mui/material";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { ToastContainer, toast } from "react-toastify";
import Checkbox from "@mui/material/Checkbox";
import "react-toastify/dist/ReactToastify.css";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../../COMPONENTS/header/Header";
import MyProSidebar from "../../../COMPONENTS/sidebar/Sidebar";
import Topbar from "../../../COMPONENTS/navbar/Topbar";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AuthContext from "../../../CONTEXT/AuthProvider";

const ViewUserDetails = () => {
  const { auth } = useContext(AuthContext);
  const accessToken = auth.accessToken;

  const isNonMobile = useMediaQuery("(min-width:600px)");
  const location = useLocation();
  const [subscribersList, setSubscribersList] = useState([]);

  const [isDisputeManagement, setDisputeManagement] = useState(
    location.state.userDetails.isDisputeManagement
  );
  const [isNameLookup, setIsNameLookup] = useState(
    location.state.userDetails.isNameLookup
  );
  const [isPressureLetter, setIsPressureLetter] = useState(
    location.state.userDetails.isPressureLetter
  );

  const handleChangeCheckBox = (event) => {
    const { name, checked } = event.target;
    const newValue = checked ? "1" : "0";
    switch (name) {
      case "isDisputeManagement":
        setDisputeManagement(newValue);
        break;
      case "isNameLookup":
        setIsNameLookup(newValue);
        break;
      case "isPressureLetter":
        setIsPressureLetter(newValue);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    axios
      .get("/api/subscribers", {
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      })
      .then((response) => {
        setSubscribersList(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [accessToken]);

  const [formValues, setFormValues] = useState({
    firstName: location.state.userDetails.firstName,
    middleName: location.state.userDetails.middleName,
    lastName: location.state.userDetails.lastName,
    username: location.state.userDetails.username,
    email: location.state.userDetails.email,
    subscriberName: location.state.userDetails.subscriberName,
    digitalLendor: location.state.userDetails.digitalLendor,
    phoneNumber: location.state.userDetails.phoneNumber,
  });

  const handleFormSubmit = async (values) => {
    const firstname = values.firstName;
    const middlename = values.middleName;
    const lastname = values.lastName;
    const username = values.username;
    const email = values.email;
    const subscriberName = values.subscriberName;
    const digitalLendor = values.digitalLendor;
    const phoneNumber = values.phoneNumber;
    const id = location.state.userDetails.id;
    try {
      const data = {
        firstname,
        middlename,
        lastname,
        username,
        email,
        subscriberName,
        digitalLendor,
        phoneNumber,
        isDisputeManagement,
        isNameLookup,
        isPressureLetter,
        id,
      };

      await axios.post("/api/update-user", data, {
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      });

      setFormValues({
        ...formValues,
        firstname,
        middlename,
        lastname,
        username,
        email,
        subscriberName,
        digitalLendor,
      });

      toast.success("User updated successfully!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="app">
      <MyProSidebar />
      <main className="content">
        <Topbar />
        <Box m="20px">
          <Header title="VIEW USER" subtitle="View a user in the system" />

          <Formik
            onSubmit={handleFormSubmit}
            initialValues={formValues}
            validationSchema={checkoutSchema}
          >
            {({
              values,
              errors,
              touched,
              handleBlur,
              handleChange,
              handleSubmit,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gap="30px"
                  gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="First Name"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.firstName}
                    name="firstName"
                    error={!!touched.firstName && !!errors.firstName}
                    helperText={touched.firstName && errors.firstName}
                    sx={{ gridColumn: "span 2" }}
                  />
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Middle Name"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.middleName}
                    name="middleName"
                    sx={{ gridColumn: "span 2" }}
                  />
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Last Name"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.lastName}
                    name="lastName"
                    error={!!touched.lastName && !!errors.lastName}
                    helperText={touched.lastName && errors.lastName}
                    sx={{ gridColumn: "span 2" }}
                  />
                  <FormControl
                    fullWidth
                    variant="filled"
                    sx={{ gridColumn: "span 2" }}
                  >
                    <InputLabel id="digitalLendor-label">
                      Digital Lendor
                    </InputLabel>
                    <Select
                      labelId="digitalLendor-label"
                      name="digitalLendor"
                      value={values.digitalLendor}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={!!touched.digitalLendor && !!errors.digitalLendor}
                      helperText={touched.digitalLendor && errors.digitalLendor}
                    >
                      <MenuItem value=""></MenuItem>
                      {subscribersList.map((subscriber) => (
                        <MenuItem
                          key={subscriber.id}
                          value={subscriber.subscriber_name}
                        >
                          {subscriber.subscriber_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Phone Number"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.phoneNumber}
                    name="phoneNumber"
                    error={!!touched.phoneNumber && !!errors.phoneNumber}
                    helperText={touched.phoneNumber && errors.phoneNumber}
                    sx={{ gridColumn: "span 2" }}
                  />
                  <TextField
                    fullWidth
                    variant="filled"
                    type="text"
                    label="Username"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.username}
                    name="username"
                    error={!!touched.username && !!errors.username}
                    helperText={touched.username && errors.username}
                    sx={{ gridColumn: "span 2" }}
                  />
                  <TextField
                    fullWidth
                    variant="filled"
                    type="email"
                    label="email"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.email}
                    name="email"
                    error={!!touched.email && !!errors.email}
                    helperText={touched.email && errors.email}
                    sx={{ gridColumn: "span 2" }}
                  />
                  <FormControl
                    fullWidth
                    variant="filled"
                    sx={{ gridColumn: "span 2" }}
                  >
                    <InputLabel id="subscriber-label">Subscriber</InputLabel>
                    <Select
                      labelId="subscriber-label"
                      name="subscriberName"
                      value={values.subscriberName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        !!touched.subscriberName && !!errors.subscriberName
                      }
                      helperText={
                        touched.subscriberName && errors.subscriberName
                      }
                    >
                      <MenuItem value=""></MenuItem>
                      {subscribersList.map((subscriber) => (
                        <MenuItem
                          key={subscriber.id}
                          value={subscriber.subscriber_name}
                        >
                          {subscriber.subscriber_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl component="fieldset" variant="standard">
                    <FormLabel component="legend">Access</FormLabel>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isDisputeManagement === "1"}
                            onChange={handleChangeCheckBox}
                            name="isDisputeManagement"
                          />
                        }
                        label="Disputes Management"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isNameLookup === "1"}
                            onChange={handleChangeCheckBox}
                            name="isNameLookup"
                          />
                        }
                        label="Name Lookup"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={isPressureLetter === "1"}
                            onChange={handleChangeCheckBox}
                            name="isPressureLetter"
                          />
                        }
                        label="Pressure Letters"
                      />
                    </FormGroup>
                  </FormControl>
                </Box>
                <Box display="flex" justifyContent="end" mt="20px">
                  <Button type="submit" color="success" variant="contained">
                    Update User
                  </Button>
                </Box>
                <ToastContainer />
              </form>
            )}
          </Formik>
        </Box>
      </main>
    </div>
  );
};

const checkoutSchema = yup.object().shape({
  firstName: yup.string().required("required"),
  lastName: yup.string().required("required"),
  username: yup.string().required("required"),
  email: yup.string().required("required"),
  subscriberName: yup.string().required("required"),
});

export default ViewUserDetails;
